<template>
  <header>
    <div class="headerContent">
      <img src="../../assets/logo.svg" alt="" />

      <div class="box">
        <div class="texts">
          <p class="mostText">Surreal São Paulo</p>
          <p>VTEX</p>
        </div>
      </div>
    </div>

    <div class="headerContent">
      <img src="../../assets/icone-bell.svg" alt="" />

      <div class="user">
        <p class="mostText">Olá, Joaquim</p>
        <img src="../../assets/usuario.svg" alt="" />
      </div>
    </div>
  </header>
</template>

<script>
export default {};
</script>

<style>
@import url("./style.scss");
</style>

<style scoped>
p {
  margin-bottom: 0;
}
</style>